import { Modal, Space, Table, Tag } from "antd";
import Column from "antd/lib/table/Column";
import React, { useEffect, useState } from "react";
import { workshopsApi } from "../../../api/workshop.api";
import { QueryParam } from "types/query";
import { Shop, Workshops } from "types/shop";
import dayjs from "utils/dayjs";
import { Pagination } from "components/Pagination";
import { ClockCircleOutlined } from "@ant-design/icons";

export const SubmitHistory = ({
  selectedShop,
  visible,
  onCancel,
}: {
  selectedShop?: Partial<Shop>;
  visible: boolean;
  onCancel: () => void;
}) => {
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState<QueryParam>({ page: 1, limit: 10 });
  const [total, setTotal] = useState(0);
  const [workshops, setWorkshops] = useState<Workshops[]>([]);

  useEffect(() => {
    if (selectedShop) fetchData();
  }, [selectedShop, query]);

  const fetchData = async () => {
    setLoading(true);
    const res = await workshopsApi.findAll({
      ...query,
      shopId: selectedShop?.id,
    });
    setLoading(false);
    setWorkshops(res.data.workshops);
    setTotal(res.data.total);
  };
  return (
    (<Modal
      footer={null}
      title={
        <>
          <p style={{ marginBottom: "0.3em" }}>Lịch sử điểm danh </p>
          <span style={{ fontSize: "15px", fontWeight: "normal" }}>
            {selectedShop?.name}
          </span>
        </>
      }
      open={visible}
      onCancel={onCancel}
    >
      <Table dataSource={workshops} pagination={false} loading={loading}>
        <Column
          title="Thời gian họp"
          dataIndex="date"
          key="age"
          render={(text, record: Workshops) => (
            <span>{dayjs(record.bookingDate).format("DD/MM/YYYY")}</span>
          )}
        />
        <Column
          title="Trạng thái điểm danh"
          render={(text, record: Workshops) => (
            <>
              {record.isSubmitted ? (
                <>
                  <Tag color={"success"}>
                    {" "}
                    <b>Đã điểm danh</b>{" "}
                  </Tag>
                </>
              ) : (
                <Tag color={"red"}>
                  <b>Chưa điểm danh</b>{" "}
                </Tag>
              )}
            </>
          )}
        />
        <Column
          title="Thời gian điểm danh"
          render={(text, record: Workshops) => (
            <i>
              {record.submittedAt > 0
                ? dayjs.unix(record.submittedAt).format("HH:mm, DD/MM/YYYY")
                : "--"}
            </i>
          )}
        />
      </Table>
      <div style={{ marginTop: "3em" }}>
        <Pagination
          total={total}
          currentPage={query.page}
          onChange={({ limit, page }) => {
            query.page = page;
            query.limit = limit;
            setQuery({ ...query });
          }}
        />
      </div>
    </Modal>)
  );
};
